import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  CircularProgress,
  FormControl,
  Grid,
  IconButton,
  TextareaAutosize,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import React from "react";
import { useState } from "react";
import CommonDatePicker from "../../../Base/views/CommonDatePicker";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { UploadTaxDeclarationProofHelper } from "../../helper/TaxDeclarationHelper";
import { convertBase64, getUserData } from "../../../Base/helper/baseFunctions";
import { toast } from "react-toastify";
import { v4 as uuidv4 } from "uuid";

const actionSummaryStyle = {
  marginTop: "1%",
  minHeight: 50,
  maxHeight: 50,
  borderRadius: "10px 10px 0px 0px",
  "&.Mui-expanded": {
    minHeight: 50,
    maxHeight: 50,
    backgroundColor: "#f3edfd",
  },
};

const TDStep3 = ({
  handleInputChange,
  disableEdit = false,
  step3,
  setStep3,
  stepUpdate3,
  setStepUpdate3,
  houseObj,
  activeStep,
  setActiveStep,
  toggleState,
  toggleDeclarationState,
  checkViewType,
  defaultValue,
  comments,
  setComments,
  fileProof,
  setFileProof,
  handleView,
  checkDeclarationStatus,
}) => {
  const maxProperty = 3;
  const [expanded, setExpanded] = useState(0);
  const [errors, setErrors] = useState([]);
  const [uploadStatus, setUploadStatus] = useState({});
  const [files, setFiles] = useState([]);
  const { show, disable_ap } = checkDeclarationStatus || {};
  const handleChange = (event, index) => {
    let newArr = [...step3];
    let item = newArr[index];
    delete item?.emp_tax_declaration_fk;
    delete item?.employee_fk;
    item = { ...item, [event.target.name]: event.target.value };
    newArr[index] = item;
    setStep3(newArr);
  };

  const hanldeAddStore = () => {
    let objDetail = JSON.parse(JSON.stringify(houseObj));
    setStep3(step3.concat(JSON.parse(JSON.stringify([objDetail]))));
  };

  const onRemoveStore = (e, index) => {
    const list = [...step3];
    list.splice(index, 1);
    setStep3([...list]);
    const errorList = [...errors];
    errorList.splice(index, 1);
    setErrors([...errorList]);
  };

  const handleUpdateChange = (event, housePropertyId) => {
    const newArr = stepUpdate3?.map((item) => {
      if (item?.lease_period_id === housePropertyId) {
        return {
          ...item,
          [event.target.name]: event.target.value,
        };
      }
      return item;
    });
    setStepUpdate3(newArr);
  };
  const validate = () => {
    let ret_value = [];
    step3?.forEach((store, index) => {
      const error = {};
      if (!store.rent_from) error.rent_from = "Rent From is required";
      if (!store.rent_to) error.rent_to = "Rent To is required";
      if (!store.rent_per_month) error.rent_per_month = "Rent is required";
      if (!store.city) error.city = "City is required";
      if (!store.lp_address) error.lp_address = "Address is required";
      if (!store.landl_name) error.landl_name = "Name is required";
      if (!store.landl_panno) error.landl_panno = "PAN is required";
      const temp = errors;
      temp[index] = error;
      setErrors([...temp]);
      ret_value.push(Object.values(error).every((e) => e === ""));
    });
    return ret_value;
  };

  const handleSubmit = () => {
    if (checkViewType) {
      handleInputChange({ target: { name: "tds3", value: step3 } });
      setActiveStep(activeStep + 1);
    } else if (!validate().includes(false)) {
      handleInputChange({ target: { name: "tds3", value: step3 } });
      setActiveStep(activeStep + 1);
    }
  };
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [selectedRow, setSelectedRow] = useState(null);

  const handleMenuClick = (event, rowKey) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(rowKey);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleFileUpload = async (event, name) => {
    const userData = getUserData();
    const file = event.target.files[0];
    if (file) {
      try {
        const allowedMimeTypes = [
          "application/pdf",
          "application/msword",
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        ];
        if (!allowedMimeTypes.includes(file.type)) {
          toast.error(
            "Invalid File type. Accepted file types: .pdf, .doc, .docx",
            {
              duration: 2000,
            }
          );
          return;
        }
        const b64string = await convertBase64(file);

        const ext = file?.name?.split(".").at(-1).toLowerCase();
        const content_type = file.type;
        const filename =
          `${userData?.domain}/Payroll/EmployeeTDProof/` +
          uuidv4() +
          "." +
          name +
          "." +
          ext;

        setFiles((prev) => [
          ...prev,
          {
            b64string,
            filename,
            content_type,
            td_component: name,
          },
        ]);
        setUploadStatus((prev) => ({
          ...prev,
          [name]: "uploaded",
        }));
      } catch (error) {
        console.error("Error during file upload: ", error);
      }
    }
  };

  const handleDeselectFile = (name) => {
    setFiles((prev) => prev.filter((file) => file.td_component !== name));
    setUploadStatus((prev) => ({
      ...prev,
      [name]: null,
    }));
  };

  const handleSaveDocs = async (name, files) => {
    const fileToSave = files.find((file) => file?.td_component === name);
    setUploadStatus((prev) => ({
      ...prev,
      [name]: "loading",
    }));
    if (fileToSave) {
      try {
        const res = await UploadTaxDeclarationProofHelper({
          ...fileToSave,
          old_file_path: fileProof[fileToSave?.td_component],
        });

        if (res?.data?.statuscode === 200) {
          setFileProof((prev) => ({
            ...prev,
            [fileToSave?.td_component]: res?.data?.data?.[0]?.cloud_file,
          }));
        }
      } finally {
        setUploadStatus((prev) => ({
          ...prev,
          [name]: null,
        }));
        setFiles((prev) => prev.filter((file) => file.td_component !== name));
      }
    } else {
      setUploadStatus((prev) => ({
        ...prev,
        [name]: null,
      }));
    }
  };
  return (
    <>
      <Box>
        {!disableEdit && (
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="h6">
              House Rent Exemption (as per limits U/s 10(13A))
            </Typography>
            <Box display="flex" flexDirection="row-reverse">
              {step3 && step3?.length <= maxProperty && (
                <Box mb={1}>
                  <Button
                    onClick={hanldeAddStore}
                    variant="contained"
                    size="medium"
                    startIcon={<AddIcon />}
                    className="mpl-primary-btn"
                    disabled={disable_ap}
                  >
                    Add Lease Period {step3.length + 1} &nbsp;&nbsp;
                  </Button>
                </Box>
              )}
            </Box>
          </Box>
        )}
        {step3?.map((store, id) => {
          return (
            <Accordion
              key={id}
              expanded={id === expanded}
              onChange={(e) =>
                id === expanded ? setExpanded("") : setExpanded(id)
              }
              sx={{ borderRadius: "10px" }}
            >
              <AccordionSummary
                expandIcon={<KeyboardArrowDownIcon />}
                id="controlled-panel-header-1"
                aria-controls="controlled-panel-content-1"
                sx={actionSummaryStyle}
              >
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                  <Typography variant="subtitle1" color={"inherit"}>
                    Lease Period {id + 1}
                  </Typography>
                  <Box sx={{ display: "flex", alignItems: "center", gap: "3px", mr: "5px" }}>
                    {!disable_ap && (
                      <IconButton
                        aria-label="delete"
                        onClick={(e) => {
                          e.stopPropagation();
                          onRemoveStore(e, id);
                        }}
                      >
                        <DeleteIcon style={{ color: "#637381" }} />
                      </IconButton>
                    )}
                    {!disableEdit && (
                      <Box
                        display="flex"
                        justifyContent={"space-around"}
                        alignItems={"center"}
                      >
                        <IconButton
                          aria-label="actions"
                          aria-controls={
                            open ? "proof-actions-menu" : undefined
                          }
                          aria-haspopup="true"
                          aria-expanded={open ? "true" : undefined}
                          onClick={(e) =>{
                            e.stopPropagation();
                            handleMenuClick(e, `lease_period_${id}`)}
                          }
                        >
                          <MoreVertIcon />
                        </IconButton>
                        <Menu
                          id="proof-actions-menu"
                          anchorEl={anchorEl}
                          open={open}
                          onClose={(e) =>{
                            e.stopPropagation();
                            handleMenuClose()
                          }}
                          MenuListProps={{
                            "aria-labelledby": "actions-button",
                          }}
                          sx={{
                            "& .MuiPaper-root": {
                              boxShadow: "none",
                            },
                          }}
                        >
                          <MenuItem>
                            {!checkViewType && (
                              <>
                                {!uploadStatus[selectedRow] && (
                                  <Tooltip
                                    title={
                                      !toggleState
                                        ? "Proof upload window disabled"
                                        : "Proof Upload"
                                    }
                                  >
                                    <Box
                                      display={"flex"}
                                      ml={"-8px"}
                                      alignItems={"center"}
                                    >
                                      <IconButton
                                        color="primary"
                                        component="label"
                                        disabled={
                                          !toggleState ||
                                          uploadStatus[selectedRow] ===
                                            "uploaded"
                                        }
                                        sx={{
                                          "&:hover": {
                                            backgroundColor: "transparent", // remove hover background
                                          },
                                        }}
                                      >
                                        <CloudUploadIcon sx={{ mr: 1.5 }} />
                                        <Typography sx={{ fontSize: "0.9rem" }}>
                                          Proof Upload
                                        </Typography>
                                        <input
                                          type="file"
                                          hidden
                                          onChange={(event) =>{
                                            event.stopPropagation();
                                            handleFileUpload(event, selectedRow)}
                                          }
                                        />
                                      </IconButton>
                                    </Box>
                                  </Tooltip>
                                )}

                                {uploadStatus[selectedRow] === "loading" ? (
                                  <CircularProgress
                                    size={24}
                                    sx={{ display: "block", margin: "0 auto" }}
                                  />
                                ) : uploadStatus[selectedRow] === "uploaded" ? (
                                  <Box
                                    sx={{
                                      width: "100%",
                                      display: "flex",
                                      justifyContent: "space-around",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Tooltip title={"Save Proof"}>
                                      <IconButton
                                        sx={{ color: "primary" }}
                                        onClick={(e) =>{
                                          e.stopPropagation();
                                          handleSaveDocs(selectedRow, files)}
                                        }
                                      >
                                        <CheckCircleIcon color="primary" />
                                      </IconButton>
                                    </Tooltip>
                                    <Tooltip title={"Deselect Proof"}>
                                      <IconButton
                                        sx={{ color: "grey.500" }}
                                        onClick={(e) =>{
                                          e.stopPropagation();
                                          handleDeselectFile(selectedRow)}
                                        }
                                      >
                                        <CancelIcon />
                                      </IconButton>
                                    </Tooltip>
                                  </Box>
                                ) : null}
                              </>
                            )}
                          </MenuItem>
                          <MenuItem
                            onClick={(e) => {
                              e.stopPropagation();
                              handleView(fileProof[selectedRow])}}
                            disabled={
                              selectedRow === null ||
                              !fileProof[selectedRow] ||
                              !toggleState
                            }
                          >
                            <Tooltip
                              title={
                                !toggleState
                                  ? ""
                                  : !fileProof[selectedRow]
                                  ? "No Attachment"
                                  : "View Attachment"
                              }
                            >
                              <Box display="flex" alignItems="center" gap={0.5}>
                                <VisibilityIcon sx={{ mr: 1 }} />
                                <Typography sx={{ fontSize: "0.9rem" }}>
                                  {!fileProof[selectedRow]
                                    ? "No Attachment"
                                    : "View Attachment"}
                                </Typography>
                              </Box>
                            </Tooltip>
                          </MenuItem>
                        </Menu>
                      </Box>
                    )}
                  </Box>

                </Box>
              </AccordionSummary>
              <AccordionDetails key={id}>
                <Grid container>
                  <Grid item xs={12} sm={6} md={4} p={1}>
                    <FormControl fullWidth>
                      <CommonDatePicker
                        size="small"
                        name="rent_from"
                        label="Rent From"
                        pickerType="date"
                        required={true}
                        disabled={
                          disableEdit ||
                          toggleDeclarationState ||
                          checkViewType ||
                          disable_ap
                        }
                        pickerFormat="dd/MM/yyyy"
                        DefaultDTvalue={store?.rent_from || ""}
                        maxDate={new Date(store?.rent_to)}
                        textFieldSx={{
                          backgroundColor:
                            toggleDeclarationState ||
                            checkViewType ||
                            disable_ap
                              ? "#f3edfd"
                              : "#ffffff",
                          borderRadius: "5px",
                        }}
                        handleChange={(value) =>
                          handleChange(
                            {
                              target: {
                                name: "rent_from",
                                value: `${
                                  value?.getFullYear() +
                                  "-" +
                                  ("0" + (value.getMonth() + 1)).slice(-2) +
                                  "-" +
                                  ("0" + value.getDate()).slice(-2)
                                }`,
                              },
                            },
                            id
                          )
                        }
                        {...(errors[id] &&
                          errors[id].rent_from && {
                            error: true,
                            helperText: errors[id].rent_from,
                          })}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} p={1}>
                    <FormControl fullWidth>
                      <CommonDatePicker
                        size="small"
                        name="rent_to"
                        label="Rent To"
                        required={true}
                        pickerType="date"
                        disabled={
                          disableEdit ||
                          toggleDeclarationState ||
                          checkViewType ||
                          disable_ap
                        }
                        pickerFormat="dd/MM/yyyy"
                        DefaultDTvalue={store?.rent_to || ""}
                        minDate={new Date(store?.rent_from)}
                        textFieldSx={{
                          backgroundColor:
                            toggleDeclarationState ||
                            checkViewType ||
                            disable_ap
                              ? "#f3edfd"
                              : "#ffffff",
                          borderRadius: "5px",
                        }}
                        handleChange={(value) =>
                          handleChange(
                            {
                              target: {
                                name: "rent_to",
                                value: `${
                                  value?.getFullYear() +
                                  "-" +
                                  ("0" + (value.getMonth() + 1)).slice(-2) +
                                  "-" +
                                  ("0" + value.getDate()).slice(-2)
                                }`,
                              },
                            },
                            id
                          )
                        }
                        {...(errors[id] &&
                          errors[id].rent_to && {
                            error: true,
                            helperText: errors[id].rent_to,
                          })}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} p={1}>
                    <TextField
                      required
                      size="small"
                      onChange={(e) => {
                        const rawValue = e.target.value.replace(/,/g, "");
                        const validNumberRegex = /^\d*\.?\d{0,2}$/;
                        if (rawValue === "" || validNumberRegex.test(rawValue)) {
                          handleChange({
                            target: {
                              name: "rent_per_month",
                              value: +rawValue,
                            },
                          }, id)
                        }
                      }
                      }
                      name="rent_per_month"
                      label="Rent per Month"
                      fullWidth
                      disabled={
                        disableEdit ||
                        toggleDeclarationState ||
                        checkViewType ||
                        disable_ap
                      }
                      type="text"
                      sx={{
                        backgroundColor:
                          toggleDeclarationState || checkViewType || disable_ap
                            ? "#f3edfd"
                            : "#ffffff",
                        borderRadius: "5px",
                      }}
                      onKeyPress={(e) =>
                        e.target.value?.length >= 7 && e.preventDefault()
                      }
                      value={store?.rent_per_month ? Number(store?.rent_per_month).toLocaleString("en-IN") : ""}
                      {...(errors[id] &&
                        errors[id].rent_per_month && {
                          error: true,
                          helperText: errors[id].rent_per_month,
                        })}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} p={1}>
                    <FormControl fullWidth>
                      <TextField
                        label="City"
                        value={store?.city}
                        required={true}
                        variant={"outlined"}
                        name="city"
                        size="small"
                        disabled={
                          disableEdit ||
                          toggleDeclarationState ||
                          checkViewType ||
                          disable_ap
                        }
                        sx={{
                          backgroundColor:
                            toggleDeclarationState ||
                            checkViewType ||
                            disable_ap
                              ? "#f3edfd"
                              : "#ffffff",
                          borderRadius: "5px",
                        }}
                        onChange={(e) => handleChange(e, id)}
                        {...(errors[id] &&
                          errors[id].city && {
                            error: true,
                            helperText: errors[id].city,
                          })}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} p={1}>
                    <TextField
                      required
                      size="small"
                      onChange={(e) => handleChange(e, id)}
                      name="lp_address"
                      label="Lease Property Address"
                      fullWidth
                      disabled={
                        disableEdit ||
                        toggleDeclarationState ||
                        checkViewType ||
                        disable_ap
                      }
                      value={store?.lp_address || ""}
                      sx={{
                        backgroundColor:
                          toggleDeclarationState || checkViewType || disable_ap
                            ? "#f3edfd"
                            : "#ffffff",
                        borderRadius: "5px",
                      }}
                      {...(errors[id] &&
                        errors[id].lp_address && {
                          error: true,
                          helperText: errors[id].lp_address,
                        })}
                    />
                  </Grid>
                </Grid>

                <Typography variant="h6" p={1}>
                  Add Landlord Details
                </Typography>
                <Grid container>
                  <Grid item xs={12} sm={6} md={4} p={1}>
                    <TextField
                      required
                      size="small"
                      onChange={(e) => handleChange(e, id)}
                      name={"landl_name"}
                      label="Name"
                      fullWidth
                      disabled={
                        disableEdit ||
                        toggleDeclarationState ||
                        checkViewType ||
                        disable_ap
                      }
                      value={store?.landl_name || ""}
                      sx={{
                        backgroundColor:
                          toggleDeclarationState || checkViewType || disable_ap
                            ? "#f3edfd"
                            : "#ffffff",
                        borderRadius: "5px",
                      }}
                      {...(errors[id] &&
                        errors[id].landl_name && {
                          error: true,
                          helperText: errors[id].landl_name,
                        })}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} p={1}>
                    <TextField
                      required
                      size="small"
                      onChange={(e) => handleChange(e, id)}
                      name="landl_panno"
                      label="PAN Number"
                      fullWidth
                      disabled={
                        disableEdit ||
                        toggleDeclarationState ||
                        checkViewType ||
                        disable_ap
                      }
                      value={store?.landl_panno || ""}
                      sx={{
                        backgroundColor:
                          toggleDeclarationState || checkViewType || disable_ap
                            ? "#f3edfd"
                            : "#ffffff",
                        borderRadius: "5px",
                      }}
                      onKeyPress={(e) =>
                        e.target.value?.length >= 10 && e.preventDefault()
                      }
                      {...(errors[id] &&
                        errors[id].landl_panno && {
                          error: true,
                          helperText: errors[id].landl_panno,
                        })}
                    />
                  </Grid>
                </Grid>
                {!disableEdit && (
                  <>
                    <Typography variant="h6" p={1}>
                      Approved
                    </Typography>
                    <Grid container>
                      {(checkViewType || show) && (
                        <Grid item xs={12} sm={6} md={4} p={1}>
                          <TextField
                            size="small"
                            type="text"
                            disabled={!checkViewType}
                            autoComplete="first_name"
                            onChange={(e) => {
                              const rawValue = e.target.value.replace(/,/g, "");
                              const validNumberRegex = /^\d*\.?\d{0,2}$/;
                              if (rawValue === "" || validNumberRegex.test(rawValue)) {
                                handleUpdateChange({
                                  target: {
                                    name: "rent_per_month_approved",
                                    value: +rawValue,
                                  },
                                }, store?.lease_period_id)
                              }
                            }
                            }
                            name={`rent_per_month_approved`}
                            label={"Rent per Month"}
                            placeholder="Enter Amount"
                            fullWidth
                            value={
                              stepUpdate3?.find(
                                (item) =>
                                  item.lease_period_id ===
                                  store?.lease_period_id
                              )?.rent_per_month_approved ? Number(stepUpdate3?.find(
                                (item) =>
                                  item.lease_period_id ===
                                  store?.lease_period_id
                              )?.rent_per_month_approved).toLocaleString("en-IN") : ""
                            }
                            onWheel={(e) => e.target.blur()}
                            sx={{
                              backgroundColor: !checkViewType
                                ? "#f3edfd"
                                : "#ffffff",
                              borderRadius: "7px",
                            }}
                          />
                        </Grid>
                      )}

                      <Grid item xs={12} sm={6} md={4} p={1}>
                        <TextareaAutosize
                          minRows={2}
                          maxRows={3}
                          disabled={!checkViewType}
                          placeholder={
                            checkViewType ? "Enter Comment" : "Comment"
                          }
                          value={
                            stepUpdate3?.find(
                              (item) =>
                                item.lease_period_id === store?.lease_period_id
                            )?.rent_comment_approved || ""
                          }
                          name={`rent_comment_approved`}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (value?.length <= 75) {
                              handleUpdateChange(e, store?.lease_period_id);
                            }
                          }}
                          style={{
                            width: "100%",
                            backgroundColor: checkViewType
                              ? "#ffffff"
                              : "#f3edfd",
                            borderRadius: "10px",
                            padding: "8px",
                            fontSize: "14px",
                            fontFamily: "inherit",
                            border: "1px solid #ccc",
                            resize: "none",
                          }}
                        />
                        {checkViewType && (
                          <Typography
                            variant="caption"
                            sx={{
                              display: "block",
                              textAlign: "right",
                              color: "#888",
                            }}
                          >
                            {stepUpdate3?.find(
                              (item) =>
                                item.lease_period_id === store?.lease_period_id
                            )?.rent_comment_approved?.length || 0}
                            /75
                          </Typography>
                        )}
                      </Grid>
                    </Grid>
                  </>
                )}
              </AccordionDetails>
            </Accordion>
          );
        })}
      </Box>
      {!disableEdit && (
        <Box
          sx={{ display: "flex", justifyContent: "space-between", bottom: 30 }}
        >
          {activeStep !== 0 && (
            <Button
              sx={{ marginRight: "10px", mt: 5 }}
              type="submit"
              variant="outlined"
              size="medium"
              onClick={() => setActiveStep(activeStep - 1)}
            >
              Back
            </Button>
          )}
          {activeStep < 5 && (
            <Button
              sx={{ marginRight: "10px", mt: 5 }}
              size="medium"
              variant="contained"
              className="mpl-primary-btn"
              onClick={() => handleSubmit()}
            >
              Next
            </Button>
          )}
        </Box>
      )}
    </>
  );
};

export default TDStep3;
